import React from 'react';
import { parseEntities } from '../../utils/helpers';

const CardSeries = ({ title, intro, permalink, poster_desktop, poster_mobile, poster_series }) => {
	return (
		<li className="tile-series music-card">
			<div className={`tile-series__img-container music-card__image-wrapper`}>

				<img src={poster_series} alt={title} className={`music-card__image tile-series__img`} />

				<div className="music-card__title-wrapper">
					<a className={`tile-series__link`} href={permalink}>
						<h3 className="heading-s tile-series__title">{parseEntities(title)}</h3>
					</a>
				</div>
			</div>
			<div className={`tile-series__information`}>
				<div className="music-card__content music-card__content--no-button">

					{intro && <p className="music-card__description music-card__description--purple music-card__flexible">{intro}</p>}
				</div>
			</div>
		</li>


	);
};

export default CardSeries;
